import Image from "next/image";
import { conditions } from "../../../../../helpers";
import { ConditionName, IFullScreenIconProps } from "../../../../../interfaces";
import IMAGES from "../../../../../images/importImages";
import { useAppSelector } from "redux-share";
import { shallowEqual } from 'react-redux'

const FullScreenIcon = (props: IFullScreenIconProps) => {

    useAppSelector(({ videoData: { isComplexPortrait, videoElementSizeInfo, params } }) => ({ isComplexPortrait, videoElementSizeInfo, params }), shallowEqual);
    useAppSelector(({ controller: { isFullScreen, showMiniPlayer } }) => ({ isFullScreen, showMiniPlayer }), shallowEqual);

    return (
        <div className={`pl-flex pl-items-center ${conditions(ConditionName.isComplexPortrait) && "pl-flex pl-items-end pl-w-[35px] pl-h-[35px]"}`} onClick={props.onClick}>
            {conditions(ConditionName.isSplusEnvironment) ? (
                <i 
                    className={`fa-solid ${conditions(ConditionName.isFullScreen) ? "fa-compress" : "fa-expand"} pl-text-white pl-cursor-pointer ${conditions(ConditionName.isMiniPlayer) ? "pl-text-[13px]" : "pl-text-[22px]"}`} 
                    onMouseOver={props.onMouseOver}
                    onMouseLeave={props.onMouseLeave}
                />
            ) : (
                <Image
                    src={conditions(ConditionName.isFullScreen) ? IMAGES.nonFullScreen : IMAGES.fullScreen}
                    alt="fullScreen-icon"
                    className={`pl-cursor-pointer`}
                    width={conditions(ConditionName.isMiniPlayer) ? 13 : conditions(ConditionName.isComplexPortrait) ? 17 : 22}
                    height={conditions(ConditionName.isMiniPlayer) ? 14 : conditions(ConditionName.isComplexPortrait) ? 17 : 22}
                    onMouseOver={props.onMouseOver}
                    onMouseLeave={props.onMouseLeave}
                />
            )}
        </div>
    )
}

export default FullScreenIcon;